module.exports = __webpack_public_path__ + "images/emoji/waxing_crescent_moon.85d6569362b770a9337d.png";